<template>
  <v-form @keyup.native.enter="submit">
  
  <v-card>
    <v-card-title class="headline py-2">
      Редактирование логотипа
      <v-spacer></v-spacer>
      <v-btn icon @click="closeDialog" class="mx-0"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    
    <v-card-text>
      <v-text-field
        v-model="formLogo.name"
        label="Название"
        :error-messages="veeErrors.collect('Название')"
        v-validate="'required'"
        data-vv-name="Название"
        required
      ></v-text-field>
  
      <label>Тип логотипа</label>
      <v-radio-group v-model="formLogo.type" row>
        <v-radio label="Текст" value="text" ></v-radio>
        <v-radio label="Картинка" value="image"></v-radio>
      </v-radio-group>
  
      <v-layout v-if="formLogo.type==='image'" class="text-xs-center mb-2" row wrap>
        <v-flex xs12>
          <img v-if="formLogo.image_url" :src="formLogo.image_url" alt="avatar" width="244" height="64" style="max-width: 300px">
          <br>
          <small>Размер картинки 244x64</small>
        </v-flex>
        <v-flex xs12 class="mt-1">
          <v-btn color="secondary" dark @click="showCrop=!showCrop">Загрузить изображение<v-icon right dark>cloud_upload</v-icon></v-btn>
          <my-upload
            :width="244"
            :height="64"
            field="file"
            @crop-success="cropSuccess"
            v-model="showCrop"
            url=""
            :params="params"
            :headers="headers"
            langType="ru"
          />
        </v-flex>
      </v-layout>
  
      <template v-else>
        <v-text-field
          v-model="formLogo.text"
          label="Текст"
          :error-messages="veeErrors.collect('Текст')"
          v-validate="'required'"
          data-vv-name="Текст"
          required
        ></v-text-field>
    
        <v-select
          label="Шрифт"
          :items="fonts"
          v-model="formLogo.font"
          no-data-text="Нет доступных шрифтов"></v-select>
    
        <v-select
          label="Размер шрифта"
          :items="fontsizes"
          v-model="formLogo.size"
          no-data-text="Отсутствуют размеры"></v-select>
    
        <v-layout row>
          <v-flex xs6>
            <v-checkbox
              label="Жирный"
              v-model="formLogo.bold"
              color="primary"
              hide-details
            />
        
            <v-checkbox
              label="Наклонный"
              v-model="formLogo.italic"
              color="primary"
              hide-details
            />
        
            <div class="mb-2">
              <p class="pa-0 mt-1" style="float: left">Цвет шрифта: </p>
              <div :style="{display:'inline-block', marginLeft:'10px', cursor: 'pointer' , width:'60px', height: '30px', background: formLogo.color}" @click="showColors=!showColors"></div>
              <swatches-picker v-show="showColors" v-model="colors" @input="setColor('color')"></swatches-picker>
            </div>
        
            <div class="mb-2">
              <p class="pa-0 mt-1" style="float: left">Цвет фона: </p>
              <div :style="{display:'inline-block', marginLeft:'10px', cursor: 'pointer' , width:'60px', height: '30px', background: formLogo.background}" @click="showBgColors=!showBgColors"></div>
              <swatches-picker v-show="showBgColors" v-model="backgroundColors" @input="setColor('background')"></swatches-picker>
            </div>
          </v-flex>
      
          <v-flex xs6>
            <label>Предпросмотр</label>
            <div class="logo-preview"
                 :style="{
                  fontSize: formLogo.size,
                  fontStyle: (formLogo.italic) ? 'italic' : 'normal',
                  fontWeight: (formLogo.bold) ? 'bold' : 'normal',
                  fontFamily: formLogo.font,
                  color: formLogo.color,
                  backgroundColor: formLogo.background
                }"
            >{{formLogo.text}}</div>
      
          </v-flex>
        </v-layout>
      </template>
    </v-card-text>
    
    <v-divider></v-divider>
  
    <v-card-actions class="pa-3">
      <v-btn color="success" @click.prevent="submit" type="submit" :disabled="status.btnDisabled">Сохранить</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
    </v-card-actions>
  </v-card>
  </v-form>
</template>

<script>
import { Swatches } from 'vue-color'
import myUpload from 'vue-image-crop-upload'
import {mapState} from 'vuex'

export default {
  name: 'LogoForm',

  components:{
    'swatches-picker': Swatches,
    'my-upload': myUpload,
  },

  props:{
    logo:{
      type: Object,
      required: true
    },
    element:{
      type: String,
      required: true
    },
    dialog:{
      type: Boolean,
      required: true,
      default: false,
    },
    editMode:{
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed:{
    ...mapState(`app/account`, ['postId']),
    formTitle(){
      return (this.editMode) ? 'Редактирование логотипа' : 'Добавить логотип'
    },
  },
  
  mounted(){
    this.formLogo = this.logo
  },

  data(){
    return{
      showCrop: false,
      params: {},
      headers: {
        'DMS-POST-ID': this.postId
      },
      showColors: false,
      showBgColors: false,
      fonts: ['Arial', 'Times New Roman', 'Verdana', 'Comic Sans MS', 'Courier New', 'Georgia', 'Helvetica', 'Impact', 'Sans-Serif', 'Serif', 'Tahoma', 'Times', 'Trebuchet MS'],
      fontsizes: ['10px', '12px', '14px', '16px', '18px', '20px', '24px', '26px', '28px', '30px', '32px', '36px'],
      colors: {
        hex: '#000000',
        hsl: {
          h: 0,
          s: 0,
          l: 0,
          a: 1
        },
        hsv: {
          h: 0,
          s: 0,
          v: 0,
          a: 1
        },
        rgba: {
          r: 0,
          g: 0,
          b: 0,
          a: 1
        },
        a: 1
      },
      backgroundColors: {
        hex: '#000000',
        hsl: {
          h: 0,
          s: 0,
          l: 0,
          a: 1
        },
        hsv: {
          h: 0,
          s: 0,
          v: 0,
          a: 1
        },
        rgba: {
          r: 0,
          g: 0,
          b: 0,
          a: 1
        },
        a: 1
      },
      status:{
        btnDisabled: false,
        text: '',
        className:'green--text darken-1'
      },
      formLogo: {},
      
    }
  },

  watch: {
    logo: function() {
      this.formLogo = this.logo
    }
  },

  methods:{
    setColor(type){
      if (type === 'color'){
        this.showColors = false
        this.formLogo.color = this.colors.hex
      } else if( type === 'background'){
        this.showBgColors = false
        this.formLogo.background = this.backgroundColors.hex
      }
    },

    cropSuccess(imageUrl, field){
      // console.log('-------- crop success --------');
      this.formLogo.image_url = imageUrl;
    },

    // cropUploadSuccess(jsonData, field){
    //   this.formLogo.image_name = jsonData.name
    //   this.formLogo.image_url = 'http://orgschema.lsc' + jsonData.url
    // },

    fileLoaded(eventData){
      this.formLogo.image_name = eventData.filename
      this.formLogo.image_url = eventData.url
    },

    submit(){
      
      
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.status={ btnDisabled: true, text: 'Сохранение', className:'grey--text lighten-1' }
          if(this.editMode === true){
            this.$store.dispatch('orgstructure/updateLogo', this.formLogo).then( response => {
              this.status = { btnDisabled: false, text: 'Сохранено', className:'green--text darken-1' }
              this.$emit('logo-saved', this.formLogo)
            }).catch( error => {
              this.status = { btnDisabled: false, text: 'Ошибка', className:'red--text darken-1' }
            })
          } else {
            this.$store.dispatch('orgstructure/createLogo', { logo: this.formLogo, element: this.element } ).then( response => {
              this.status = { btnDisabled: false, text: 'Сохранено', className:'green--text darken-1' }
              this.formLogo = response.logo_data
              this.$emit('logo-saved', this.formLogo)
            }).catch( error => {
              this.status = { btnDisabled: false, text: 'Ошибка', className:'red--text darken-1' }
            })
          }
          return false
        }
      })
    },

    closeDialog(){
      this.$emit('close-dialog', true)
    },
  },

}
</script>

<style scoped>
  .logo-preview {
    width: 244px;
    height: 64px;
    margin: 30px auto;
    line-height: 64px;
    text-align: center;
    padding: 0 10px;
    overflow: hidden;
  }
</style>


// WEBPACK FOOTER //
// src/apps/org/components/Logo/LogoForm.vue